import { MEventTarget } from "../types";

type ServicesParams = {
  selector: string;
}

export default class Services {
  params: ServicesParams;
  wrapper: Element | null | undefined;
  activeEl: Element | null | undefined;

  constructor(params: ServicesParams) {
    this.params = params;
    this.delegateHandler = this.delegateHandler.bind(this);
    this.init();
  }

  init() {
    const { selector } = this.params;

    this.wrapper = document.querySelector(selector);
    
    if (window.outerWidth <= 820) {
      if (this.wrapper) {
        this.wrapper.addEventListener('click', this.delegateHandler);
      }
    }
  }

  delegateHandler(e: Event) {
    const target = e.target as MEventTarget;

    if (target && target.matches) {
      if (target.matches('.gb-services-title')) {
        this.toggleService(target);
      }
    }
  }

  toggleService(target: MEventTarget) {
    const el = target.closest('.gb-services-container');
    
    if (this.activeEl && this.activeEl !== el) {
      this.activeEl.classList.remove('is-open');
      this.activeEl = null;
    }
    
    if (el) {
      el.classList.toggle('is-open');

      if (el.classList.contains('is-open')) {
        this.activeEl = el;
      }
    }
  }
}
